import styled from 'styled-components';

const StyledExternalAnchor = styled.a`
  color: ${({ theme }) => theme.ANCHOR};
  cursor: pointer;
`;

export default StyledExternalAnchor;
